<template>
  <v-layout column align-center class="player-avatar">
    <v-layout column>
      <span
        class="difference"
        v-if="difference !== null"
        :style="{ color: diffColor }">
        {{ difference }}
      </span>
      <vue-circle
        class="surroundProgress"
        style="position: relative"
        ref="circle"
        :progress="progress"
        :size="100"
        :reverse="false"
        line-cap="round"
        :fill="fill"
        empty-fill="rgba(0, 0, 0, .1)"
        :animation-start-value="0.0"
        :start-angle="30"
        insert-mode="append"
        :thickness="5"
        :show-percent="false"
        legend-class="relocate_legend">
        <v-avatar
          class="player-avatar-avatar"
          :size="avatarSize"
          style="position: absolute; top: 5px; left: 5px">
          <img :src="player.imgUrl" @error="defaultImageProfile" />
        </v-avatar>
      </vue-circle>
      <img
        class="injured-badge"
        v-if="lastReport && lastReport.injury"
        :src="require('@/assets/icons/injured_players.png').default" />
      <span class="text-center">{{ player.lastName }}</span>
    </v-layout>
    <read-player-message
      v-if="lastReport"
      :player-name="`${player.firstName} ${player.lastName}`"
      :comment="lastReport.comment"></read-player-message>
  </v-layout>
</template>

<script>
import ReadPlayerMessage from "./ReadPlayerMessage"
import VueCircle from "vue2-circle-progress-vk"

export default {
  name: "PlayerAvatarInfo",
  components: { ReadPlayerMessage, VueCircle },
  props: ["player", "printable"],
  data() {
    return {
      color: null,
      difference: null,
      diffColor: null,
      readiness: null,
      fill: {
        color: "#fff",
      },
      progress: 0,
    }
  },

  mounted() {
    this.init()
  },

  computed: {
    lastReport() {
      return this.lastReports[0]
    },

    lastReports() {
      return this.$store.getters["reports/lastReports"](this.player.uid, 2)
    },

    avatarSize() {
      return this.printable ? 25 : 90
    },
  },

  methods: {
    init() {
      this.readiness = 100
      this.color = "white"
      if (this.lastReports.length > 0) {
        const lastStatus = this.reportReadiness(this.lastReports[0])
        const secondLastStatus = this.lastReports[1]
          ? this.reportReadiness(this.lastReports[1])
          : false
        this.readiness = lastStatus
        if (secondLastStatus && typeof secondLastStatus === "number") {
          this.difference = lastStatus - secondLastStatus
          if (lastStatus >= secondLastStatus) {
            this.diffColor = "rgba(40,247,71,1)"
            this.difference = `+${this.difference}`
          } else {
            this.diffColor = "red"
          }
        }
        this.color =
          this.readiness >= 80
            ? "rgba(40,247,71,1)"
            : this.readiness >= 50
            ? "orange"
            : "red"
      }

      this.$refs.circle.updateProgress(this.readiness)
      this.$refs.circle.updateFill({ color: this.color })
    },

    defaultImageProfile(event) {
      event.target.src = require("@/assets/icons/defaultProfileImg.png").default
    },

    reportReadiness(report) {
      return (
        ((11 -
          report.soreness +
          (11 - report.fatigue) +
          (11 - report.stress) +
          (11 - report.sleep)) *
          10) /
        4
      )
    },

    showPlayerStatus() {
      this.$router.push({
        name: "PlayerStatus",
        params: { id: this.player.uid },
      })
    },
  },

  watch: {
    lastReports() {
      this.init()
    },
  },
}
</script>

<style scoped lang="sass">
.surroundProgress :deep(.relocate_legend)
  position: absolute
  bottom: -45px

.player-avatar
  margin: auto
  min-width: 90px
  position: relative

  .player-avatar-circular
    // margin-bottom: 10px

  .text-center
    text-align: center

  .difference
    position: absolute
    top: 0
    left: 0

  .injured-badge
    position: absolute
    bottom: 20px
    right: 0
    width: 20px
</style>
